export default "https://cdn-static.gokick.com/assets/e031f09406d9a12f4f19fb28fc50e3428375be91/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";